import { COURT_IMAGES }
    from "../../data/courtImages";

function CourtCard({
    court,
    selected,
    onClick,
}) {

    return (

        <div
            onClick={onClick}
            style={{
                ...styles.card,

                ...(selected
                    ? styles.selected
                    : {}),
            }}
        >

            <div style={styles.imageWrapper}>

                <img
                    src={
                        COURT_IMAGES[
                        court.sport
                        ]
                    }
                    alt={court.name}
                    style={styles.image}
                />

            </div>

            <div style={styles.content}>

                <div style={styles.topRow}>

                    <h3 style={styles.title}>
                        {court.name}
                    </h3>

                    <div style={styles.sportTag}>
                        {court.sport}
                    </div>

                </div>

                <p style={styles.location}>
                    {court.location}
                </p>

                <div style={styles.bottomRow}>

                    <p style={styles.price}>
                        ${court.pricePerHour}
                    </p>

                    <span style={styles.perHour}>
                        / hour
                    </span>

                </div>

            </div>

        </div>
    );
}

const styles = {

    card: {

        width: "100%",

        borderRadius: "24px",

        overflow: "hidden",

        background:
            "rgba(0,40,70,0.82)",

        border:
            "1px solid rgba(255,255,255,0.08)",

        cursor: "pointer",

        transition:
            "all 0.25s ease",

        backdropFilter:
            "blur(12px)",

        boxShadow:
            "0 10px 30px rgba(0,0,0,0.25)",
    },

    selected: {

        border:
            "2px solid #00f5a0",

        boxShadow:
            "0 0 20px rgba(0,245,160,0.35)",

        transform:
            "translateY(-3px)",
    },

    imageWrapper: {

        width: "100%",

        height: "240px",

        overflow: "hidden",
    },

    image: {

        width: "100%",

        height: "100%",

        objectFit: "cover",

        objectPosition:
            "center center",

        transition:
            "transform 0.4s ease",
    },

    content: {

        padding: "22px",
    },

    topRow: {

        display: "flex",

        justifyContent:
            "space-between",

        alignItems: "center",

        gap: "12px",

        marginBottom: "12px",
    },

    title: {

        color: "#fff",

        fontSize: "22px",

        fontWeight: "700",

        margin: 0,
    },

    sportTag: {

        padding:
            "6px 12px",

        borderRadius: "999px",

        background:
            "rgba(0,245,160,0.12)",

        border:
            "1px solid rgba(0,245,160,0.25)",

        color: "#00f5a0",

        fontSize: "12px",

        fontWeight: "600",

        textTransform:
            "capitalize",
    },

    location: {

        color: "#b6c2cf",

        fontSize: "14px",

        marginBottom: "18px",
    },

    bottomRow: {

        display: "flex",

        alignItems: "baseline",

        gap: "6px",
    },

    price: {

        color: "#00f5a0",

        fontSize: "26px",

        fontWeight: "800",

        margin: 0,
    },

    perHour: {

        color: "#94a3b8",

        fontSize: "14px",
    },
};

export default CourtCard;